export const TAIWAN_COUNTRY_ID = 77;
export const TAIWAN_CAMPAIGN_CREATION_RESTRICTED_MESSAGE =
  'You are not allowed to create Taiwan campaigns';
export const TAIWAN_CAMPAIGN_APPROVAL_RESTRICTED_MESSAGE =
  'You are not allowed to approve Taiwan campaigns';

const normalizeEmail = (email?: string): string =>
  String(email || '').trim().toLowerCase();

export const isTaiwanCampaignCreationAllowed = (
  countryID: number | string | undefined,
  userEmail?: string,
): boolean => {
  if (Number(countryID) !== TAIWAN_COUNTRY_ID) {
    return true;
  }

  const isAllowedAll = (window as any).Grab?.config?.PORTAL_CONFIG?.holos
    ?.isTaiwanCampaignCreationAllowedAll;

  if (isAllowedAll !== false) {
    return true;
  }

  const whitelistedCreators = (window as any).Grab?.config?.PORTAL_CONFIG
    ?.holos?.whitelistedTaiwanCampaignCreators;
  const normalizedUserEmail = normalizeEmail(userEmail);

  return Boolean(
    normalizedUserEmail
    && Array.isArray(whitelistedCreators)
    && whitelistedCreators.some(
      (creatorEmail) => normalizeEmail(creatorEmail) === normalizedUserEmail,
    ),
  );
};

export const isTaiwanCampaignApprovalAllowed = (
  countryID: number | string | undefined,
  userEmail?: string,
): boolean => {
  if (Number(countryID) !== TAIWAN_COUNTRY_ID) {
    return true;
  }

  const isAllowedAll = (window as any).Grab?.config?.PORTAL_CONFIG?.holos
    ?.isTaiwanCampaignApprovalAllowedAll;

  if (isAllowedAll !== false) {
    return true;
  }

  const whitelistedApprovers = (window as any).Grab?.config?.PORTAL_CONFIG
    ?.holos?.whitelistedTaiwanCampaignApprovers;

  const normalizedUserEmail = normalizeEmail(userEmail);

  return Boolean(
    normalizedUserEmail
    && Array.isArray(whitelistedApprovers)
    && whitelistedApprovers.some(
      (approverEmail) => normalizeEmail(approverEmail) === normalizedUserEmail,
    ),
  );
};
